import { render, staticRenderFns } from "./TheBaie.vue?vue&type=template&id=0fb24024&scoped=true&"
import script from "./TheBaie.vue?vue&type=script&lang=js&"
export * from "./TheBaie.vue?vue&type=script&lang=js&"
import style0 from "./TheBaie.vue?vue&type=style&index=0&id=0fb24024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb24024",
  null
  
)

export default component.exports